import { Facebook, Instagram } from 'lucide-react';
import { CONTACT } from '../data/site';

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#0A0A0C] py-16" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
        <img
          src="/logo.png"
          alt="Rith's Burger"
          className="mx-auto h-28 w-auto"
          data-testid="footer-logo"
        />
        <p className="font-serif-accent mt-3 text-lg text-zinc-400">Artesanal de verdade!</p>
        <div className="mt-6 flex justify-center gap-4">
          <a
            href={CONTACT.instagram}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram da Riths Burger"
            data-testid="footer-instagram-link"
            className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-zinc-300 transition-all duration-300 hover:border-[#FF5500] hover:text-[#FF5500]"
          >
            <Instagram size={18} />
          </a>
          <a
            href={CONTACT.facebook}
            target="_blank"
            rel="noreferrer"
            aria-label="Facebook da Riths Burger"
            data-testid="footer-facebook-link"
            className="grid h-11 w-11 place-items-center rounded-full border border-white/15 text-zinc-300 transition-all duration-300 hover:border-[#FF5500] hover:text-[#FF5500]"
          >
            <Facebook size={18} />
          </a>
        </div>
        <p className="font-mono-alt mt-10 text-xs uppercase tracking-[0.25em] text-zinc-600">
          © 2026 Riths Burger — Hamburgueria Artesanal. Todos os direitos reservados.
        </p>
      </div>
    </footer>
  );
}
